import * as types from './types'

export const loadSurveyForm = (value) => ({
    type: types.LOAD_SURVEY,
    payload: value
})

export const prepareResponseData = (value) => ({
    type: types.PREPARE_RESPONSE,
    payload: value
})

export const updateResponseData = (value) => ({
    type: types.UPDATE_RESPONSE,
    payload: value
})

export const hasSurveyLoaded = (hasLoaded) => ({
    type: types.HAS_DETAIL_LOADED,
    payload: hasLoaded
})

export const showAlert = (value) => ({
    type: types.SHOW_ALERT,
    payload: value
})

export const showConfirmationModal = (value) => ({
    type: types.SHOW_CONFIRM_MODAL,
    payload: value
})

export const updateConfirmationModal = (value) => ({
    type: types.UPDATE_CONFIRM_MODAL,
    payload: value
})

export const showSurveyFormAfterSubmitModal = (value) => ({
    type: types.SHOW_SURVEY_FORM_AFTER_SUBMIT_MODAL,
    payload: value
})

export const updateSubmittedDate = (value) => ({
    type: types.UPDATE_SUBMITTED_DATE,
    payload: value
}) 

export const updateModifiedDate = (value) => ({
    type: types.UPDATE_MODIFIED_DATE,
    payload: value
}) 

export const updateIsClosed = (value) => ({
    type: types.UPDATE_IS_CLOSED,
    payload: value
})

export const setAppID = (value) => ({
    type: types.SET_APP_IDD,
    payload: value
})